<p>super-class-edit works!</p>
